<template>
  <div class="container-fluid mt--7">
    <div class="row">
      <div class="col">
        <div class="card mb-3">
          <div class="row no-gutters">

            <div class="col-12">
              <div class="card-body">
                <slot name="pageContentArea"></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FullPageContent'
};
</script>
